import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'expenseType',
	state : {
		expenseTypes: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/catalogs/expenses_type') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel'};

				const resp = yield call(all, 'ExpenseType', data)
				const expenseTypes = resp.results;

				yield put({ type: 'querySuccess', payload: {
					expenseTypes: expenseTypes,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: payload.hotel.objectId};

				if (data.parent_category)
					data.parent_category = {__type: 'Pointer', className: 'ExpenseType', objectId: payload.parent_category.objectId};

				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'ExpenseType', payload.objectId, data);
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'ExpenseType', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				expenseTypes: state.expenseTypes.concat(action.payload.expenseTypes),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				expenseTypes: action.payload.expenseTypes,
				skip: 0,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			expenseTypes: [action.payload, ...state.expenseTypes]
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.expenseTypes, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)

			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {

			let expense = {};

			// Identificamos si el registro contiene hijos (es decir es una categoría principal)
			// o es no contiene hijos (es una categoría hijo)
			if (action.payload.type === 'principal')
				expense = _.find(state.expenseTypes, {objectId: action.payload.objectId});
			else
				expense = _.find(state.expenseTypes, {objectId: action.payload.parent_category.objectId});


			if ((expense.children && expense.children.length === 0) || !expense.children) {
				// Si no contiene hijos, entonces eliminamos la categoría principal
				state.expenseTypes = _.without(state.expenseTypes, _.find(state.expenseTypes, {objectId: expense.objectId}));

			} else {
				// Si contiene hijos, entonces eliminamos la categoría hija
				let children = _.find(expense.children, {objectId: action.payload.objectId});
				expense.children = _.without(expense.children, children);
			}

			return {
				...state,
    			expenseTypes: state.expenseTypes
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/expenseType.js